import { useL18nContext } from '../../../../../ContextProvider/L18n';
import { KEYS } from '../../../../../../../l18n/constants';
import computeClassName from '../../../../../../../utils/computeClassName';
const constants = Object.freeze({
  CLASSNAME_BASE: 'max-w-cc-25ch font-extralight text-cc-200 sm:text-cc-300 text-cc-white text-center'
});

function getComputedCountryName(countryName) {
  let computedCountryName = countryName;

  if (!!countryName) {
     const lowerCaseCountryName = countryName.toLowerCase();
     if (
       (lowerCaseCountryName.indexOf('united states') > -1) ||
       (lowerCaseCountryName.indexOf('gambia') > -1) ||
       (lowerCaseCountryName.indexOf('bahamas') > -1) ||
       (lowerCaseCountryName.indexOf('maldives') > -1) ||
       (lowerCaseCountryName.indexOf('congo')> -1) ||
       (lowerCaseCountryName.indexOf('netherlands')> -1)
     ) {
       computedCountryName = `The ${computedCountryName}`;
     }
  }
  return computedCountryName;
}


function getComputedHeroText(count, countryName, locale, getTranslationFor) {
//  const formattedCount = new Intl.NumberFormat('en-US').format(!!count?count:0);
  const formattedCount = new Intl.NumberFormat(locale).format(!!count?count:0);

  let heroText = '';
  if(!countryName || !countryName.length) {
    if(!!count) {
      if(count === 1) {
        //heroText = 'There is 1 Partner serving worldwide';
        heroText = getTranslationFor(KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_WORLDWIDE);
      }
      else {
        //heroText = `There are ${formattedCount} partners serving worldwide`;
        heroText = `${getTranslationFor(KEYS.L18N_KEY_LABEL_THERE_ARE)} ${formattedCount} ${getTranslationFor(KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_WORLDWIDE)}`;
      }
    }
    else {
      //heroText = 'There are no partners serving';
      heroText = getTranslationFor(KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_NO_PARTNERS_SERVING);
    }
  }
  else {
    if(!!count) {
      if(count === 1) {
        //heroText = `There is 1 partner serving in ${countryName}`;
        heroText = `${getTranslationFor(KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_IN)} ${countryName}`;
      }
      else {
        //heroText = `There are ${formattedCount} partners serving in ${countryName}`;
        heroText = `${getTranslationFor(KEYS.L18N_KEY_LABEL_THERE_ARE)} ${formattedCount} ${getTranslationFor(KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_IN)} ${countryName}`;
      }
    }
    else {
      //heroText = `There are no partners serving in ${countryName}`;
      heroText = `${getTranslationFor(KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_NO_PARTNERS_SERVING)} ${countryName}`;
    }
  }
  return heroText;
}

export default function HeroText({foundPartnerCount, selectedCountryName, className}) {
  const { currentLocale, getTranslationFor } = useL18nContext();
  const computedCountryName = getComputedCountryName(selectedCountryName);
  const computedHeroText = getComputedHeroText(foundPartnerCount, computedCountryName, currentLocale, getTranslationFor);
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  return (
    <h2 className={computedClassName}>{computedHeroText}</h2>
  );
}
